import controllerState from "../../service/state/controller.state";
import { observer } from "mobx-react-lite";

const ItemEventLogsController = observer((props) => {
  const rowDate = props.date.date;
  return (
    <div className="log_item ">
      <div className="log_item_cell log_item_date_cell">{rowDate}</div>
      <div className="flx_row">
        {controllerState.history_controller
          .filter((t) => t.tag_active)
          .map((tag) => {
            const cell = tag.data.find((m) => m.modification === rowDate);
            const key = tag.id_tag ?? tag.name_tag;
            return cell ? (
              <div className="log_item_cell" key={key}>
                {cell.parameter_value}
              </div>
            ) : (
              <div className="log_item_cell" key={key}></div>
            );
          })}
      </div>
    </div>
  );
});

export default ItemEventLogsController;
